import { FC, memo } from 'react'
import { Tooltip, Badge, Flex } from '@chakra-ui/react'

import { CATEGORIES_OBJECT } from 'constants/variables'

type Props = {
  category?: string
  label?: string
}

const CategoryBadge: FC<Props> = ({ category, label }) => {
  if (!category) return <></>

  const categoryName = CATEGORIES_OBJECT[category] ? CATEGORIES_OBJECT[category].name : ''
  const categoryColor = CATEGORIES_OBJECT[category] ? CATEGORIES_OBJECT[category].color : ''
  const Icon: any = CATEGORIES_OBJECT[category] ? CATEGORIES_OBJECT[category].Icon : <></>

  return (
    <Tooltip label={label}>
      <Badge colorScheme={categoryColor} fontSize="xs">
        <Flex alignItems="center" gap={1}>
          <Icon />
          {categoryName}
        </Flex>
      </Badge>
    </Tooltip>
  )
}

export default memo(CategoryBadge)
